import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, CalendarDays } from "lucide-react";
import { format } from "date-fns";

export default function InnoventureTestSuccess() {
  const location = useLocation();
  const navigate = useNavigate();
  
  const testTitle = location.state?.testTitle;
  const completedAt = location.state?.completedAt;
  const completionMessage = location.state?.employerMessage;

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#7c3aed]/10 via-background to-[#a855f7]/10 flex items-center justify-center p-4">
      <Card className="max-w-2xl w-full">
        <CardContent className="pt-8 pb-8 px-6 space-y-6">
          {/* Success Icon */}
          <div className="flex justify-center">
            <div className="w-20 h-20 bg-gradient-to-br from-[#7c3aed] to-[#a855f7] rounded-full flex items-center justify-center">
              <CheckCircle2 className="h-12 w-12 text-white" />
            </div>
          </div>

          {/* Thank You Message */}
          <div className="text-center space-y-2">
            <h1 className="text-3xl font-bold text-foreground">
              Thank You!
            </h1>
            <p className="text-muted-foreground">
              Your test has been submitted successfully
            </p>
          </div>

          {/* Test Details */}
          {testTitle && (
            <div className="bg-muted/50 rounded-lg p-4 space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-muted-foreground">Test</span>
                <span className="text-sm font-semibold text-foreground">{testTitle}</span>
              </div>
              {completedAt && (
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-muted-foreground">Submitted</span>
                  <span className="text-sm font-semibold text-foreground">
                    {format(new Date(completedAt), "PPp")}
                  </span>
                </div>
              )}
            </div>
          )}

          {/* Custom Completion Message */}
          {completionMessage && (
            <div className="bg-gradient-to-r from-[#7c3aed]/10 to-[#a855f7]/10 rounded-lg p-4 border border-[#7c3aed]/20">
              <div 
                className="text-sm text-foreground prose prose-sm max-w-none"
                dangerouslySetInnerHTML={{ __html: completionMessage }}
              />
            </div>
          )}

          {/* Results Declaration Banner */}
          <div className="bg-gradient-to-r from-[#00a65a]/10 to-[#00a65a]/20 rounded-lg p-4 border border-[#00a65a]/30 flex items-center gap-3">
            <CalendarDays className="h-6 w-6 text-[#00a65a]" />
            <p className="text-foreground font-semibold">
              Results will be declared in the 3rd week of December
            </p>
          </div>

          {/* What's Next Section */}
          <div className="space-y-3">
            <h2 className="text-lg font-semibold text-foreground">What happens next?</h2>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <span className="text-[#00a65a] mt-1">•</span>
                <span>Your responses are being evaluated by our system</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#00a65a] mt-1">•</span>
                <span>Results will be declared in the 3rd week of December</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#00a65a] mt-1">•</span>
                <span>You will be notified via email once results are available</span>
              </li>
            </ul>
          </div>

          {/* Back to Dashboard Button */}
          <Button
            onClick={() => navigate("/innoventure-app")}
            className="w-full bg-[#00a65a] hover:bg-[#00a65a]/90 text-white"
          >
            Back to Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
